import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import { AppShell } from "@/components/layout/app-shell";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { AuthProvider } from "@/components/providers/auth-provider";
import { Toaster } from "@/components/ui/sonner";
import { queryClient } from "@/lib/query-client";
import { AdminPage } from "@/pages/admin-page";
import { CreateGroupPage } from "@/pages/create-group-page";
import { EditGroupPage } from "@/pages/edit-group-page";
import { GroupPage } from "@/pages/group-page";
import { HomePage } from "@/pages/home-page";
import { LoginPage } from "@/pages/login-page";
import { NotFoundPage } from "@/pages/not-found-page";
import { PrivacyPage } from "@/pages/privacy-page";
import { SettingsPage } from "@/pages/settings-page";
import { SignupPage } from "@/pages/signup-page";

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        {/* AuthProvider sits inside the router so its children can navigate,
            and inside QueryClientProvider so signOut can clear the cache. */}
        <AuthProvider>
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/rejestracja" element={<SignupPage />} />
            {/* Public: linked from the signup form before any account exists. */}
            <Route path="/prywatnosc" element={<PrivacyPage />} />

            <Route element={<ProtectedRoute />}>
              <Route element={<AppShell />}>
                <Route path="/" element={<HomePage />} />
                <Route path="/grupy/nowa" element={<CreateGroupPage />} />
                <Route path="/grupy/:groupId" element={<GroupPage />} />
                <Route path="/grupy/:groupId/edytuj" element={<EditGroupPage />} />
                <Route path="/ustawienia" element={<SettingsPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Route>
            </Route>
          </Routes>
          {/* Outside the shell, so "account closed" survives the sign-out redirect. */}
          <Toaster position="top-center" closeButton />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
